import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { getToken } from "@/lib/api";

const AuthContext = createContext(null);

function clearToken() {
  localStorage.removeItem("csrago_token");
  localStorage.removeItem("ap_token");
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const [token, setToken] = useState(getToken());

  const loadMe = useCallback(async () => {
    const t = getToken();
    if (!t) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      clearToken();
      setToken("");
      setUser(false);
    }
  }, []);

  useEffect(() => {
    loadMe();
  }, [loadMe]);

  const applyAuth = (data) => {
    localStorage.removeItem("ap_token");
    localStorage.setItem("csrago_token", data.token);
    setToken(data.token);
    setUser(data.user);
  };

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    applyAuth(data);
    return data.user;
  };

  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    applyAuth(data);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setToken("");
    setUser(false);
  };

  const refreshUser = loadMe;

  return (
    <AuthContext.Provider value={{ user, token, login, register, logout, refreshUser, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
